import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HiArrowLeft } from 'react-icons/hi2';
import {
  DetailHeaderRoot,
  DetailBackButton,
  DetailTitleBlock,
  DetailTitle,
  DetailMetaRow,
  DetailActions,
} from './DetailHeader.styled';

interface DetailHeaderProps {
  title: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  onBack?: () => void;
}

export default function DetailHeader({ title, meta, actions, onBack }: DetailHeaderProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleBack = onBack ?? (() => navigate(-1));

  return (
    <DetailHeaderRoot>
      <DetailBackButton onClick={handleBack} aria-label={t('common.back')}>
        <HiArrowLeft size="1rem" />
      </DetailBackButton>
      <DetailTitleBlock>
        {typeof title === 'string' ? <DetailTitle>{title}</DetailTitle> : title}
        {meta ? <DetailMetaRow>{meta}</DetailMetaRow> : null}
      </DetailTitleBlock>
      {actions ? <DetailActions>{actions}</DetailActions> : null}
    </DetailHeaderRoot>
  );
}

export { DetailTitle, DetailMetaRow, DetailActions };
